import { IsNotEmpty, IsString, MaxLength } from 'class-validator';

export class RejectAccessRequestCommand {
  @IsNotEmpty()
  @IsString()
  @MaxLength(255)
  login: string;

  @IsNotEmpty()
  @IsString()
  @MaxLength(255)
  message: string;
}
